<template>
  <a
    :href="item.url"
    target="_blank"
    rel="noopener noreferrer"
    class="group flex items-center gap-3 rounded-lg border border-[var(--border)] bg-[var(--surface)] px-3 py-2.5 backdrop-blur-md transition-all hover:border-[var(--accent)] hover:shadow-[0_0_18px_-6px_var(--accent)]"
  >
    <img
      v-if="item.img"
      :src="item.img"
      :alt="item.title"
      class="h-7 w-7 shrink-0 object-contain"
      loading="lazy"
    />
    <span
      v-else
      class="grid h-7 w-7 shrink-0 place-items-center rounded bg-[var(--accent)] font-mono text-xs font-bold text-[var(--bg)]"
      aria-hidden="true"
    >
      {{ initials }}
    </span>
    <div class="min-w-0">
      <p class="truncate font-mono text-sm text-[var(--text)]">{{ item.title }}</p>
      <p class="line-clamp-2 text-xs text-[var(--muted)]">{{ loc(item.description) }}</p>
    </div>
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { loc, type StackItem } from '../data'

const props = defineProps<{ item: StackItem }>()

const initials = computed(() =>
  props.item.title
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join(''),
)
</script>
